module.exports = __webpack_public_path__ + "static/images/marketing-graph.66581af67fd694e72752c9dee97c218a.svg";